import { Outlet } from "react-router-dom";
import { Box, Container, Grid, Paper } from "@mui/material";
import { Navigation } from "app/components";

const links = [
  { to: "informacion-general", label: "Información General" },
  { to: "establecimientos", label: "Establecimientos" },
  { to: "telefonos", label: "Teléfonos" },
  { to: "celulares", label: "Celulares" },
  { to: "correos-electronicos", label: "Correos Electrónicos" },
  { to: "paginas-web", label: "Páginas Web" },
  { to: "encargados", label: "Encargados" },
  { to: "actividades-economicas", label: "Actividades Económicas" },
  { to: "importaciones", label: "Importaciones" },
  { to: "exportaciones", label: "Exportaciones" },
  // { to: "archivos", label: "Archivos" },
  // { to: "formatos", label: "Formatos" },
];

export function GeneralLayout() {
  return (
    <Box className="animate__animated animate__fadeIn" variant="outlined">
      <Grid container>
        <Grid
          item
          xs={12}
          lg={3}
          sx={{
            borderRight: "1px solid #e6e6e6",
            borderBottom: "1px solid #e6e6e6",
            backgroundColor: "white",
          }}
        >
          <Navigation links={links} justified={false} />
        </Grid>

        <Grid item xs={12} lg={9} padding={2}>
          <Box padding={2} minHeight="100vh">
            <Outlet />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
